module.exports = __webpack_public_path__ + "img/ndyq.f65813d1.png";